import { useServiceSalaryComponent } from './useServiceSalaryComponent';

export { useServiceSalaryComponent };
